export default __webpack_public_path__ + "static/media/authImg.b295c2a6.jpg";